export default "__VITE_ASSET__Ck3S7e$8__"